module.exports = __webpack_public_path__ + "img/2.40bf08a6.jpg";